export default function (port: string, subDomain: string = 'api', endpoint: string = ''): string {
  const isProduction = process.env.NODE_ENV === 'production'
  const isBeta = process.env.NODE_ENV === 'beta'

  const baseUrl = !isProduction && !isBeta
    ? `https://localhost:${port}/`
    : isProduction
      ? `https://${subDomain}.danckuts.com/`
      : `https://beta.${subDomain}.danckuts.com/`

  return `${baseUrl}${endpoint}`
}
